import { render } from "./attendance-modal.vue?vue&type=template&id=29e824de"
import script from "./attendance-modal.vue?vue&type=script&lang=js"
export * from "./attendance-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__